/* eslint-disable */
import isFunction from '../../../Support/Is/Function/IsFunction';
import createFromCallback from './From/Callback.from';
import createFromError from './From/Error.from';
import createFromObservableCallback from './From/ObservableCallback.from';
import createFromPayload from './From/Payload.from';
import createFromPromise from './From/Promise.from';

/**
 * Create a middleware that will allow us to inject services, helpers, as well as the store into the reducers. **NOT** THE STORE.
 * This middleware replaces the need for [`redux-thunk`](https://github.com/reduxjs/redux-thunk).
 * @param {Services} services The services to inject into the reducers. **NOT** THE STORE.
 * @returns {Middle} The dependency injection middleware
 */
const cretaeDependencyInjectionMiddleware = (services) => (store) => (next) => (action) => {
  if (!isFunction(action)) {
    return next(action);
  }
  const from = {
    fromCallback: createFromCallback(store),
    fromError: createFromError(store),
    fromObservableCallback: createFromObservableCallback(store),
    fromPayload: createFromPayload(store),
    fromPromise: createFromPromise(store),
  };
  return action({ ...store, ...services, ...from });
};

export default cretaeDependencyInjectionMiddleware;
